import { DeviceGroups, DeviceIds } from '@libs/define/device_registry'
import { type DevicePid } from './define'

const asDevicePids = (devices: readonly DevicePid[]): DevicePid[] => [...devices]

export const RoYuanMars68Devices: DevicePid[] = asDevicePids(DeviceGroups.RoYuanMars68)
export const HuochaiDevice: DevicePid[] = asDevicePids(DeviceGroups.HuoChaiRenUi)
export const JingTaiMg75Devices: DevicePid[] = asDevicePids(DeviceGroups.JingTaiMg75)
export const JingTaiMer68Devices: DevicePid[] = asDevicePids(DeviceGroups.JingTaiMer68)
export const RoYuanMer68Devices: DevicePid[] = asDevicePids(DeviceGroups.RoYuanMer68)
export const RoYuanND68Devices: DevicePid[] = asDevicePids(DeviceGroups.RoYuanND68)
export const RoYuanND63Devices: DevicePid[] = asDevicePids(DeviceGroups.RoYuanND63)
export const RoYuanDevice24GList: DevicePid[] = asDevicePids(DeviceGroups.RoYuan24G)

export const RoYuanDeviceList: DevicePid[] = [
  ...DeviceGroups.RoYuanMars68,
  ...DeviceGroups.RoYuanMonsGeek,
  ...DeviceGroups.RoYuanMg68,
  ...DeviceGroups.RoYuanMer68,
  ...DeviceGroups.RoYuanND68,
  ...DeviceGroups.RoYuanND63,
]

export const RoYuanDeviceList_0005: DevicePid[] = [DeviceIds.IROKMG68ACE, DeviceIds.IROKMG68ACE_UpPlus, DeviceIds.IROKMG68ACE_W, DeviceIds.IROKMG68ACE_W_24g, ...DeviceGroups.RoYuanND68, ...DeviceGroups.RoYuanND63]

export const JingTaiDeviceList: DevicePid[] = [...DeviceGroups.JingTaiV1Base, ...DeviceGroups.JingTaiMg75, ...DeviceGroups.JingTaiMer68]
export const JingTaiV2DeviceList: DevicePid[] = asDevicePids(DeviceGroups.JingTaiV2)
export const He6UltraDeviceList: DevicePid[] = asDevicePids(DeviceGroups.He6Ultra)
export const HE3SEMouseDeviceList: DevicePid[] = asDevicePids(DeviceGroups.HE3SEMouse)
export const AmberDeviceList: DevicePid[] = asDevicePids(DeviceGroups.Amber)
export const HE2MouseDeviceList: DevicePid[] = asDevicePids(DeviceGroups.HE2Mouse)
export const WitmodDevicesList: DevicePid[] = asDevicePids(DeviceGroups.Witmod)
export const BeiYingDeviceLis: DevicePid[] = asDevicePids(DeviceGroups.BeiYing)
export const QMKDeviceList: DevicePid[] = asDevicePids(DeviceGroups.QMK)
export const Fe87v2DeviceList: DevicePid[] = asDevicePids(DeviceGroups.Fe87v2)
export const Fe87v2Device24GList: DevicePid[] = [DeviceIds.IrokFe87V2_24g, DeviceIds.IrokFe87V2IMC_24g]
export const Fe87C18DeviceList: DevicePid[] = asDevicePids(DeviceGroups.Fe87C18)
export const SlefDevMagnetList: DevicePid[] = asDevicePids(DeviceGroups.SelfDevMagnet)
export const MouseDevices: DevicePid[] = [...DeviceGroups.HE2Mouse, ...DeviceGroups.HE3SEMouse, ...DeviceGroups.Amber, ...DeviceGroups.He6Ultra]

export const supportBluetooth: DevicePid[] = [
  DeviceIds.CarotmasMars68Pro_Wireless,
  DeviceIds.CarotmasMars68Pro_Wireless_24g,
  DeviceIds.IROKMg68Max,
  DeviceIds.IROKMg68Max_24g,
  DeviceIds.CarotmasMars68_Wireless,
  DeviceIds.CarotmasMars68_Wireless_24g,
  ...DeviceGroups.HE3SEMouse,
  ...DeviceGroups.He6Ultra,
  ...DeviceGroups.Amber,
  DeviceIds.IROKMG68ACE_W,
  DeviceIds.IROKMG68ACE_W_24g,
]
